import React, { Component } from 'react';
import { connect } from 'react-redux';
import DrawerBody from 'components/ui/DrawerBody';
import DrawerHeader from 'components/ui/DrawerHeader';
import DrawerFooter from 'components/ui/DrawerFooter';
import CtaPrimary from 'components/ui/CtaPrimary';

import errorAnimationData from 'assets/error.json';
import loadingAnimationData from 'assets/loading.json';
import successAnimationData from 'assets/success.json';

import { getTranslatedString } from 'helpers/i18n';
import DrawerSuccessMessages from 'components/ui/DrawerSuccessMessages';
import Lottie from 'react-lottie';
import TicketForm from './TicketForm/TicketForm';
import { postTicket } from 'actions/maintenanceActions';
import { combineDateAndTime } from 'helpers/Formatter';

const FORM_NAME = 'add_ticket_form';

class TicketCreating extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      loading: false,
      success: false,
      formData: {},
    };
  }

  evaluateEnvironmentalTesting = values => {
    if (values.environmental_testing === false) {
      return 'not_completed';
    } else if (values.environmental_testing_result === true) {
      return 'positive';
    } else {
      return 'negative';
    }
  };

  handleSubmit = values => {
    let scheduledStartsAt;
    if (values['scheduled_starts_at_date'] && values['scheduled_starts_at_time']) {
      scheduledStartsAt = combineDateAndTime(
        values['scheduled_starts_at_date'],
        values['scheduled_starts_at_time']
      );
    }

    const payload = {
      ...values,
      abatement_date: values.abatement_date,
      environmental_testing: this.evaluateEnvironmentalTesting(values),
      scheduled_starts_at: scheduledStartsAt,
    };
    this.setState({ formData: payload, loading: true });
    this.props
      .postTicket(payload)
      .done(response => {
        this.setState({
          error: false,
          loading: false,
          success: true,
          formData: payload,
        });
        this.props.onSubmissionComplete();
      })
      .catch(error => {
        this.setState({
          error: true,
          loading: false,
          success: false,
          formData: payload,
        });
      });
  };

  render() {
    if (this.state.success) {
      return this.renderSuccess(this.state.formData);
    } else if (this.state.loading) {
      return this.renderLoading(this.state.formData);
    } else if (this.state.error) {
      return this.renderError(this.state.formData);
    } else {
      return this.renderFormWizard();
    }
  }

  renderFormWizard = () => {
    const { loading } = this.state;

    return (
      <React.Fragment>
        <DrawerHeader
          onClose={this.props.handleClose}
          title={getTranslatedString('landlordPortal.maintenance.tickets.createNewTicket')}
        />
        <DrawerBody>{this.renderForm()}</DrawerBody>
        <DrawerFooter
          primaryActionFormName={FORM_NAME}
          primaryActionText={getTranslatedString('create')}
          primaryActionDisabled={loading}
        />
      </React.Fragment>
    );
  };

  renderForm = () => {
    return (
      <TicketForm
        mode="create"
        formName={FORM_NAME}
        formData={this.state.formData}
        handleSubmit={this.handleSubmit}
        imageMaxSize={this.props.imageMaxSize}
      />
    );
  };

  renderSuccess = formData => {
    const defaultOptions = {
      loop: false,
      autoplay: true,
      animationData: successAnimationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    return (
      <DrawerSuccessMessages
        headerImageSource={<Lottie options={defaultOptions} height={150} width={150} />}
        headerText={getTranslatedString('landlordPortal.maintenance.tickets.successHeader')}
        bodyText={getTranslatedString('globalDrawer.successBody')}
        cta={
          <CtaPrimary onClick={() => this.setState({ success: false }, this.props.handleClose)}>
            {getTranslatedString('close')}
          </CtaPrimary>
        }
      />
    );
  };

  renderError = formData => {
    const defaultOptions = {
      loop: false,
      autoplay: true,
      animationData: errorAnimationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    return (
      <DrawerSuccessMessages
        headerImageSource={<Lottie options={defaultOptions} height={150} width={150} />}
        headerText={getTranslatedString('landlordPortal.maintenance.tickets.errorHeader')}
        bodyText={getTranslatedString('globalDrawer.errorBody')}
        cta={
          <CtaPrimary onClick={() => this.setState({ error: false })}>
            {getTranslatedString('globalDrawer.goBack')}
          </CtaPrimary>
        }
      />
    );
  };

  renderLoading = formData => {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: loadingAnimationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    return (
      <DrawerSuccessMessages
        headerImageSource={<Lottie options={defaultOptions} height={150} width={150} />}
        headerText={getTranslatedString('landlordPortal.maintenance.tickets.loadingHeader')}
        bodyText={getTranslatedString('globalDrawer.loadingBody')}
      />
    );
  };
}

const mapStoreToProps = store => ({ imageMaxSize: store.userTypes.imageMaxSize });
const mapDispatchToProps = { postTicket };

export default connect(mapStoreToProps, mapDispatchToProps)(TicketCreating);
